import cloneDeep from 'lodash.clonedeep';
import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  composition: null,
  eligibility: null,
  excessDetails: {
    currentExcess: null,
    newExcess: null,
    excessType: null,
    excessOptions: [],
  },
  premiumDetails: {
    currentPremium: null,
    currentFrequency: null,
    newPremium: null,
    newFrequency: null,
  },
  currentPage: 1,
  submitPolicyInProcess: false,
};

export default {
  namespaced: true,

  state: cloneDeep(INITIAL_STATE),

  mutations: {
    updateComposition(state, data) {
      state.composition = data;
    },

    updateEligibility(state, data) {
      state.eligibility = data;
    },
    
    updateCurrentExcess(state, data) {
      state.excessDetails.currentExcess = data;
    },

    updateExcessType(state, data) {
      state.excessDetails.excessType = data;
    },

    updateNewExcess(state, data) {
      state.excessDetails.newExcess = data;
    },

    updateExcessOptions(state, data) {
      state.excessDetails.excessOptions = data;
    },

    updateCurrentPremiumAndFrequency(state, data) {
      state.premiumDetails.currentPremium = data?.currentPremium;
      state.premiumDetails.currentFrequency = data?.currentFrequency;
    },

    updateNewPremiumAndFrequency(state, data) {
      state.premiumDetails.newPremium = data?.newPremium;
      state.premiumDetails.newFrequency = data?.newFrequency;
    },

    updateCurrentPage(state, data) {
      state.currentPage = data;

      if (Number(getQueryString('step')) !== Number(data)) {
        setQueryString('step', data);
      }
    },

    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },
  },

  getters: {
    getComposition: (state) => {
      return state.composition;
    },

    getEligibility: (state) => {
      return state.eligibility;
    },

    getCurrentExcess: (state) => {
      return state.excessDetails.currentExcess;
    },

    getExcessType: (state) => {
      return state.excessDetails.excessType;
    },

    getNewExcess: (state) => {
      return state.excessDetails.newExcess;
    },

    getExcessOptions: (state) => {
      return state.excessDetails.excessOptions;
    },
    
    getCurrentPremiumAndFrequency: (state) => {
      return {
        premium: state.premiumDetails.currentPremium,
        frequency: state.premiumDetails.currentFrequency,
      };
    },

    getNewPremiumAndFrequency: (state) => {
      return {
        premium: state.premiumDetails.newPremium,
        frequency: state.premiumDetails.newFrequency,
      };
    },

    getCurrentPage: (state) => {
      return state.currentPage;
    },

    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
  },
};
